import { isEmpty } from 'lodash-es'
import React, { useCallback, useEffect, useState } from 'react'

export default function useForm(initialValues, validate) {
  const [values, setValues] = useState(initialValues)
  const [errors, setErrors] = useState({})

  const handleChange = useCallback(
    (name, value) => {
      setValues((prev) => ({ ...prev, [name]: value }))
      if (validate) {
        const error = validate(name, value, values)
        setErrors((prev) => ({ ...prev, [name]: error }))
      }
    },
    [validate, values]
  )

  const validateAllFields = useCallback(() => {
    const newErrors = {}
    Object.keys(initialValues).forEach((fieldName) => {
      const error = validate(fieldName, values[fieldName], values)
      if (error) {
        newErrors[fieldName] = error
      }
    })
    setErrors(newErrors)
    return isEmpty(newErrors)
  }, [values, validate, initialValues])

  useEffect(() => {
    setValues(initialValues)
    setErrors({})
  }, [JSON.stringify(initialValues)])

  return {
    values,
    setValues,
    errors,
    setErrors,
    handleChange,
    validateAllFields,
  }
}
